import React, { useState } from "react";
import formatAmount from "../../utils/formatAmount";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  withStyles,
} from "@material-ui/core";
import { callApi } from "../../actions/base";
import { navigate } from "gatsby";
import {HTTP_METHOD} from "../../constants/http";

const styles = () => ({
  buttonAccount: {
    color: "white",
  },
  card: {
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  cardActions: {
    justifyContent: "center",
  },
});

const PackageTitle = ({ data }) => (
  <Box textAlign="center" mb={2}>
    <Typography variant="h5">
      {data.description}
    </Typography>
  </Box>
)

const PackageAmount = ({ data, classes }) => (
  <Box textAlign="center">
    {data.isTrial ? (
      <Typography variant="h4" component="h2">
        Pakiet testowy
      </Typography>
    ) : (
      <>
        <Typography variant="h4" component="h2">
          {data.itemsAmount}
        </Typography>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          zleceń weryfikacyjnych
        </Typography>
      </>
    )}
  </Box>
);

const PackagePricing = ({ data, classes }) => {
  const {
    grossTotalPrice,
    netTotalPrice,
    currency,
  } = data;
  return (
    <Box textAlign="center" my={2}>
      <Typography variant="h5">
        {formatAmount(grossTotalPrice, currency)}
      </Typography>
      <Typography className={classes.title} color="textSecondary">
        {formatAmount(netTotalPrice, currency)} netto
      </Typography>
    </Box>
  );
};

const PackageExpiry = ({ data, classes }) => (
  <Box textAlign="center">
    <Typography variant="h6" component="h2">
      {data.daysToExpiry} dni
    </Typography>
    <Typography className={classes.title} color="textSecondary">
      okres ważności
    </Typography>
  </Box>
);

const PaymentDialog = ({ handleClose, open, newPackage }) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Opłać zakupiony pakiet
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Przejdź do strony płatności i zapłać za pakiet.
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            Zostanie on aktywowany gdy otrzymamy potwierdzenie dokonania wpłaty.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" disableElevation>
            Anuluj zamówienie
          </Button>
          <a href={newPackage?.paymentUrl}>
            <Button
              color="primary"
              variant="contained"
              disableElevation
              autoFocus
            >
              Przejdź do płatności
            </Button>
          </a>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const PackageActions = ({ data }) => {
  const [newPackage, setNewPackage] = useState(null);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleCloseDialog = () => setDialogOpen(false);

  const handleSuccess = ({ data }) => {
    setNewPackage(data);
    if (data.status === "active") {
      navigate("/dashboard/packages/current");
    } else {
      setDialogOpen(true);
    }
  };

  const handleError = error => setError(error);

  const handleSubmit = () => {
    const uri = "/packages/instances";
    const payload = { packageCode: data.code };
    callApi(
      uri,
      payload,
      handleSuccess,
      handleError,
      HTTP_METHOD.POST
    );
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        onClick={handleSubmit}
      >
        {data.isTrial ? "Wypróbuj teraz" : "Kup teraz"}
      </Button>
      <PaymentDialog
        handleClose={handleCloseDialog}
        open={dialogOpen}
        newPackage={newPackage}
      />
    </>
  );
};

const PackageCard = ({ data, classes }) => (
  <Card className={classes.card} variant="outlined">
    <CardActionArea>
      <CardContent>
        <PackageTitle data={data} />
        <PackageAmount data={data} classes={classes} />
        <PackagePricing data={data} classes={classes} />
        <PackageExpiry data={data} classes={classes} />
      </CardContent>
    </CardActionArea>
    <CardActions className={classes.cardActions}>
      <PackageActions data={data} />
    </CardActions>
  </Card>
);

export default withStyles(styles)(PackageCard);
